export default __webpack_public_path__ + "static/media/view-care-admin.19c979b5.svg";